import { render } from "./MainIndex.vue?vue&type=template&id=3bb3d926&scoped=true"
import script from "./MainIndex.vue?vue&type=script&lang=js"
export * from "./MainIndex.vue?vue&type=script&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=3bb3d926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb3d926"]])

export default __exports__